import API from '@/views/Fdc/Apis/'

/**
 * Fab Save Modal Component
 * Fab 정보를 저장하는 component
 */
export default {
  name: 'fabSaveModal',
  /**
   * Modal 표시 여부
   * @param {Boolean} visible
   *
   * Modal 초기 data
   * @param {Object} initValue
   *
   * Save Method 실행 여부
   * @param {Boolean} saveReady
   *
   * Save 종료 시 실행 method
   * @param {Function} saveComplete
   *
   * Save 취소 시 실행 method
   * @param {Function} cancelSave
   *
   * Fab Manager Row Data
   * @param {Array} rows
  */
  props: [
    'visible',
    'initValue',
    'saveReady',
    'saveComplete',
    'cancelSave',
    'rows'
  ],
  watch: {
    /**
     * initValue 변화 감지
     * 초기 data를 설정합니다.
     */
    initValue: {
      deep: true,
      handler () {
        this.initData()
      }
    },
    /**
     * visible 변화 감지
     * @param {Boolean} value Modal 표시 여부
     * visible이 true일 때 getFabList method를 실행합니다.
     */
    visible (value) {
      if (value) {
        this.getFabList()
      }
    },
    /**
     * saveReady 변화 감지
     * saveReady가 true일 때 saveData method를 실행합니다.
     */
    saveReady () {
      if (this.saveReady) {
        this.saveData()
      }
    }
  },
  beforeMount () {
    this.initData()
  },
  methods: {
    /**
     * Data 초기화
     */
    resetData () {
      this.fab = null
      this.line = null
      this.area = null
      this.vendor = null
      this.eqpModel = null
      this.fabDirect = null
      this.lineDirect = null
      this.areaDirect = null
      this.vendorDirect = null
      this.eqpModelDirect = null
      this.fabList = []
      this.lineList = []
      this.areaList = []
      this.vendorList = []
      this.eqpModelList = []
      this.areaSelectValue = null
      this.areaTextValue = null
      this.vendorSelectValue = null
      this.vendorTextValue = null
      this.areaTextBoxChanged = null
      this.vendorTextBoxChanged = null
      this.prevData = null
    },
    /**
     * Fab 저장
     * Save Type에 따라 Add 또는 Edit를 실행합니다.
     */
    async saveData () {
      if (this.initValue.saveType === 'Add') {
        let fab = this.fab !== '' ? this.fab : this.fabDirect
        let line = this.line !== '' ? this.line : this.lineDirect
        let area = this.area !== '' ? this.area : this.areaDirect
        let vendor = this.vendor !== '' ? this.vendor : this.vendorDirect
        let eqpModel = this.eqpModel !== '' ? this.eqpModel : this.eqpModelDirect
        line = line.trim()
        area = area.trim()
        vendor = vendor.trim()
        eqpModel = eqpModel.trim()

        const saveData = {
          fab: fab,
          line: line,
          area: area,
          vendor: vendor,
          eqpModel: eqpModel,
          fabUseYn: 'Y',
          isNew: true
        }

        if (!this.saveValidation([saveData])) {
          return
        }

        let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')
        let self = this

        this.$dialog.confirm({
          message: message,
          cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
          confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
          onConfirm: function () {
            function saveLastProcess (response) {
              console.log('here', response)
              if (response != null && response.status === 200) {
                self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
                self.resetData()
                self.saveComplete()
              } else {
                self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
              }
            }

            API.BaseInfo.addFab([saveData]).then(result => {
              saveLastProcess(result)
            })
          },
          onCancel: function () {
            self.cancelSave()
          }
        })
      } else if (this.initValue.saveType === 'Edit') {
        const line = this.line.trim()
        const areaTextValue = this.areaTextValue.trim()
        const areaSelectValue = this.areaSelectValue
        const vendorTextValue = this.vendorTextValue.trim()
        const vendorSelectValue = this.vendorSelectValue
        const eqpModel = this.eqpModel.trim()

        const area = this.areaTextBoxChanged ? areaTextValue : areaSelectValue
        const vendor = this.vendorTextBoxChanged ? vendorTextValue : vendorSelectValue

        const data = { fab: this.fab, line, area, vendor, eqpModel }

        if (this.dataDuplicated(data, this.rows)) {
          return
        }

        if (this.dataInvalid(data)) {
          return
        }

        const saveData = { fab: this.fab, line, areaTextValue, areaSelectValue, vendorTextValue, vendorSelectValue, eqpModel }
        const mustSaveData = {
          prevData: this.prevData,
          newData: saveData
        }

        let self = this
        const message = self.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

        self.$dialog.confirm({
          message: message,
          cancelText: self.$t('fdc.COMMON.BUTTON.CANCEL'),
          confirmText: self.$t('fdc.COMMON.BUTTON.CONFIRM'),
          onConfirm: function () {
            function saveLastProcess (response) {
              if (response != null && response.status === 200) {
                self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
                self.resetData()
                self.saveComplete()
              } else {
                self.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
              }
            }

            if (mustSaveData.prevData && mustSaveData.newData) {
              API.BaseInfo.putFab(mustSaveData).then(result => saveLastProcess(result))
            }
          },
          onCancel: function () {
            self.cancelSave()
          }
        })
      }
    },
    /**
     * 초기 Data 설정
     */
    initData () {
      if (this.visible) {
        if (this.initValue.saveType === 'Add') {
          this.getFabList()
        } else if (this.initValue.saveType === 'Edit') {
          this.fab = this.initValue.fab
          this.line = this.initValue.line
          this.areaSelectValue = this.initValue.area
          this.areaTextValue = ''
          this.vendorSelectValue = this.initValue.vendor
          this.vendorTextValue = ''
          this.eqpModel = this.initValue.eqpModel
          this.getAreaList(this.initValue.fab)
          this.getVendorList(this.initValue.fab, this.initValue.area)
          this.prevData = {
            fab: this.initValue.fab,
            line: this.initValue.line,
            area: this.initValue.area,
            vendor: this.initValue.vendor,
            eqpModel: this.initValue.eqpModel
          }
        }
      }
    },
    /**
     * Fab Save Validation (Add)
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (rows) {
      for (let i in rows) {
        if (!rows[i].fab || rows[i].fab.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Fab']))
          return false
        } else if (!rows[i].line || rows[i].line.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Line']))
          return false
        } else if (!rows[i].fabUseYn || rows[i].fabUseYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Fab Usable']))
          return false
        } else if (!rows[i].area || rows[i].area.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Area']))
          return false
        } else if (!rows[i].vendor || rows[i].vendor.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vendor']))
          return false
        } else if (!rows[i].eqpModel || rows[i].eqpModel.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP Model']))
          return false
        }
        if (rows[i].fabUseYn !== 'Y' && rows[i].fabUseYn !== 'N') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Fab Usable']))
          return false
        }
      }
      return true
    },
    /**
     * Data 중복 여부 체크
     * @param {Object} data save data
     * @param {Array} datas Fab Manager Grid 전체 rows
     * @returns {Boolean} 중복 체크 성공 여부
     */
    dataDuplicated (data, datas) {
      const { fab, line, area, vendor, eqpModel } = data

      const rows = datas.filter(row => row._status)
      const dataList = rows.filter(row => row._status && row.fab === fab).map(data => data)

      const lineExist = dataList.some(dataList => dataList.line === line && dataList.line !== this.prevData.line)
      if (lineExist) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['Line']))
        // this.$dialog.alert('The line does already exist')
        return true
      }

      const areaExist = dataList.some(dataList => this.areaTextBoxChanged &&
        dataList.area === area && dataList.area !== this.prevData.area)
      if (areaExist) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['Area']))
        // this.$dialog.alert('The area does already exist')
        return true
      }

      const vendorExist = dataList.some(dataList => this.vendorTextBoxChanged &&
        dataList.area === area && dataList.vendor === vendor &&
        (dataList.area !== this.prevData.area || dataList.vendor !== this.prevData.vendor))
      if (vendorExist) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['Vendor']))
        // this.$dialog.alert('The vendor does already exist')
        return true
      }

      const eqpModelExist = dataList.some(dataList => dataList.area === area & dataList.vendor === vendor && dataList.eqpModel === eqpModel &&
        (dataList.area !== this.prevData.area || dataList.vendor !== this.prevData.vendor || dataList.eqpModel !== this.prevData.eqpModel))
      if (eqpModelExist) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_KEY_DUPLICATED', ['Eqp Model']))
        // this.$dialog.alert('The eqp model does already exist')
        return true
      }

      return false
    },
    /**
     * Fab Save Validation (Edit)
     * @param {Object} data save data
     * @returns {Boolean} Validation 성공 여부
     */
    dataInvalid (data) {
      if (data.line === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Line']))
        return true
      } else if (data.area === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Area']))
        return true
      } else if (data.vendor === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Vendor']))
        return true
      } else if (data.eqpModel === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP Model']))
        return true
      }

      return false
    },
    /**
     * Fab Combobox change method (Add)
     * Fab 변경 시 line/area 목록 조회 및 vendor/eqpModel 목록 초기화를 실행합니다.
     */
    changeFab () {
      const fab = this.fab !== '' ? this.fab : this.fabDirect
      if (!_.isEmpty(fab)) {
        this.getLineList(fab)
        this.getAreaList(fab)
      }
      this.vendorList = []
      this.eqpModelList = []
    },
    /**
     * Area Combobox change method (Add)
     * Area 변경 시 vendor 목록 조회 및 eqpModel 목록 초기화를 실행합니다.
     */
    changeArea () {
      const fab = this.fab !== '' ? this.fab : this.fabDirect
      const area = this.area !== '' ? this.area : this.areaDirect
      if (!_.isEmpty(fab) && !_.isEmpty(area)) {
        this.getVendorList(fab, area)
      }
      this.eqpModelList = []
    },
    /**
     * Vendor Combobox change method (Add)
     * Vendor 변경 시 eqpModel 목록 조회를 실행합니다.
     */
    changeVendor () {
      const fab = this.fab !== '' ? this.fab : this.fabDirect
      const area = this.area !== '' ? this.area : this.areaDirect
      const vendor = this.vendor !== '' ? this.vendor : this.vendorDirect
      if (!_.isEmpty(fab) && !_.isEmpty(area) && !_.isEmpty(vendor)) {
        this.getEqpModelList(fab, area, vendor)
      }
    },
    /**
     * Area Input tag change method (Edit)
     * Area Combobox의 활성화 여부를 변경합니다.
     */
    changeAreaInTextBox () {
      // Area Select 활성화/비활성화
      if (this.areaTextValue === '') {
        this.areaTextBoxChanged = false
      } else {
        this.areaTextBoxChanged = true
      }
    },
    /**
     * Area Combobox change method (Edit)
     * Area Input의 활성화 여부를 변경합니다.
     */
    changeAreaInSelectBox () {
      // Area Textbox 활성화/비활성화
      if (this.areaSelectValue === this.prevData.area) {
        this.areaSelectBoxChanged = false
      } else {
        this.areaSelectBoxChanged = true
      }
    },
    /**
     * Vendor Input tag change method (Edit)
     * Vendor Combobox의 활성화 여부를 변경합니다.
     */
    changeVendorInTextBox () {
      // Vendor Select 활성화/비활성화
      if (this.vendorTextValue === '') {
        this.vendorTextBoxChanged = false
      } else {
        this.vendorTextBoxChanged = true
      }
    },
    /**
     * Vendor Combobox change method (Edit)
     * Vendor Input의 활성화 여부를 변경합니다.
     */
    changeVendorInSelectBox () {
      // Vendor Textbox 활성화/비활성화
      if (this.vendorSelectValue === this.prevData.vendor) {
        this.vendorSelectBoxChanged = false
      } else {
        this.vendorSelectBoxChanged = true
      }
    },
    /**
     * Fab Key 목록 조회
     */
    async getFabList () {
      let payload = {
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getFabsString(payload)
      this.fabList = data
    },
    /**
     * Line Key 목록 조회
     * @param {String} fab fab
     */
    async getLineList (fab) {
      let payload = {
        fab: fab,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getLinesString(payload)
      this.lineList = data
    },
    /**
     * Area Key 목록 조회
     * @param {String} fab fab
     */
    async getAreaList (fab) {
      let payload = {
        fab: fab,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getAreasString(payload)
      this.areaList = data
    },
    /**
     * Vendor Key 목록 조회
     * @param {String} fab fab
     * @param {String} area area
     */
    async getVendorList (fab, area) {
      let payload = {
        fab: fab,
        area: area,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getVendersString(payload)
      this.vendorList = data
    },
    /**
     * Eqp Model Key 목록 조회
     * @param {String} fab fab
     * @param {String} area area
     * @param {String} vendor vendor
     */
    async getEqpModelList (fab, area, vendor) {
      let payload = {
        fab: fab,
        area: area,
        vendor: vendor,
        useYn: 'Y'
      }
      let data = await API.BaseInfo.getEqpModelsString(payload)
      this.eqpModelList = data
    }
  },
  data () {
    return {
      fab: null, // Fab data
      fabDirect: null, // Fab Input data (Add)
      line: null, // Line data
      lineDirect: null, // Line Input data (Add)
      area: null, // Area data
      areaDirect: null, // Area Input data (Add)
      vendor: null, // Vendor data
      vendorDirect: null, // Vendor Input data (Add)
      areaSelectValue: null, // Area Comobox data (Edit)
      areaTextValue: null, // Area Input data (Edit)
      vendorSelectValue: null, // Vendor Combobox data (Edit)
      vendorTextValue: null, // Vendor Input data (Edit)
      eqpModel: null, // EqpModel data
      eqpModelDirect: null, // EqpModel Input data (Add)
      areaTextBoxChanged: null, // Area Combobox disabled 여부 (Edit) - true:비활성화, false:활성화
      vendorTextBoxChanged: null, // Vendor Combobox disabled 여부 (Edit) - true:비활성화, false:활성화
      areaSelectBoxChanged: null, // Area Input disabled 여부 (Edit) - true:비활성화, false:활성화
      vendorSelectBoxChanged: null, // Vendor Input disabled 여부 (Edit) - true:비활성화, false:활성화
      fabList: [], // Fab Key 목록 배열
      lineList: [], // Line Key 목록 배열
      areaList: [], // Area Key 목록 배열
      vendorList: [], // Vendor Key 목록 배열
      eqpModelList: [], // EqpModel Key 목록 배열
      defaultText: 'Edit', // Comobobox option default value
      prevData: null // Fab Edit Modal open 시 저장되는 Edit 기초 data (수정 전 data)
    }
  }
}
